export enum FORM_INPUT_TYPES {
  CODE = 'CODE',
  DATE = 'DATE'
}

export const LOCALE_DATE_PATTERN = (() => {
  const currentLocale = new Intl.DateTimeFormat().resolvedOptions().locale;
  const date = new Date(2000, 5, 10);
  const dateStr = date.toLocaleDateString(currentLocale);
  const datePattern = dateStr.split('/');

  if (datePattern[0] === '10') {
    return ['DD', 'MM', 'YYYY'];
  }

  return ['MM', 'DD', 'YYYY'];
})();

export const isLocaleDDMMYYYY = LOCALE_DATE_PATTERN[0] === 'DD';

export const FORM_INPUT_COMPONENT_TYPES = {
  CODE: {
    title: 'formInputTypes.code.title',
    tip: '',
    length: 4,
    maxInputLength: [1, 1, 1, 1],
    minInputLength: [1, 1, 1, 1],
    placeholders: '',
    patterns: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
    patternMessage: 'formInputTypes.code.patternMessage',
    min: [0, 0, 0, 0],
    max: [9, 9, 9, 9],
    errorMessage: 'formInputTypes.code.errorMessage'
  },

  DATE: {
    title: 'formInputTypes.date.title',
    tip: 'formInputTypes.date.tip',
    length: 3,
    maxInputLength: [2, 2, 4],
    minInputLength: [1, 1, 4],
    placeholders: LOCALE_DATE_PATTERN,
    patterns: [/[0-9]/, /[0-9]/, /[0-9]/],
    patternMessage: 'formInputTypes.date.patternMessage',
    min: [1, 1, 2000],
    max: [isLocaleDDMMYYYY ? 31 : 12, isLocaleDDMMYYYY ? 12 : 31, new Date().getFullYear()],
    errorMessage: 'formInputTypes.date.errorMessage'
  }
} as const;
